function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.57 10.532l7.034 5.197c.802.443 1.382.214 1.582-.745l2.863-13.493C19.342.316 18.6-.217 17.833.131L1.02 6.616C-.128 7.075-.121 7.715.81 8l4.315 1.347 9.99-6.302c.47-.286.903-.132.548.183"
});
function SvgTelegramNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.5 -2 20 20"
  }, props), _ref);
}
export default SvgTelegramNew;